import React from 'react'
import TableCustom from '../../../components/table/tableCustom';
import { debouncedApiCall } from '../../../utils/app.utils';
import StateComponents from '../../../components/state-component/StateComponents';
import ContainerButton from '../../../components/button/ContainerButton';
import ContainerLayout from '../../../components/container-layout/ContainerLayout';
import ManageState from './manageState';
import { useTranslation } from 'react-i18next';
import ModalCustom from '../../../components/modal/ModalCustom';
import moment from 'moment';
import { alertActive } from '../../../components/alert/swal';

export default function InterviewStudent() {
    const { t } = useTranslation();
    const {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,

        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,

        showModal,
        handleCloseModal,
        form,
        set_form,
        handleSubmit,
        setShowModal,
        handleAPPROVE,
        remark,
        set_remark,
        degree,
        faculty,
        id_degree,
        set_id_degree,
        id_faculty,
        set_id_faculty,
        status,
        set_status
    } = ManageState()
    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("INTERVIEW_STUDENT_INTERVIEW")}

                content={
                    <div className='w-full'>
                        <ContainerButton
                            justifyContent='flex-end'
                            buttonData={[
                                {
                                    buttonProps: {
                                        onClick: () => { setShowModal('CREATE') }
                                    },
                                    key: "EDIT",
                                    label: t("INTERVIEW_STUDENT_INTERVIEW_INFO"),
                                    seq: 1,
                                    type: "EDIT",
                                },
                                {
                                    buttonProps: {
                                        onClick: () => {
                                            alertActive(t("INTERVIEW_STUDENT_APPROVED"), t("INTERVIEW_STUDENT_CONFIRM_REVIEW"), undefined, undefined, async () => {
                                                handleAPPROVE('PASS')
                                            })
                                        }
                                    },
                                    key: "DOWNLOAD_CSV",
                                    label: t("INTERVIEW_STUDENT_APPROVED"),
                                    seq: 2,
                                    type: "APPROVE"
                                },
                                {
                                    buttonProps: {
                                        onClick: () => { setShowModal('REJECT') }
                                    },
                                    key: "DOWNLOAD_CSV",
                                    label: t("INTERVIEW_STUDENT_REJECTED"),
                                    seq: 3,
                                    type: 'REJECT'
                                },
                            ]}
                        />
                        <StateComponents
                            otherProps={{ spacing: 2 }}
                            sxContainer={{ marginTop: "10px" }}
                            typeProps={[
                                {
                                    seq: 1,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        placeholder: t("INTERVIEW_STUDENT_SEARCH_NAME"),
                                        onChange: (e) => debouncedApiCall({ setItem: setKeyword, searchItem: e.target.value })
                                    }
                                },
                                {
                                    seq: 2,
                                    type: "DATE_RANGE",
                                    gridProps: {
                                        xs: 12,
                                        md: 3
                                    },
                                    fieldProps: {
                                        onchange: handleChangeDateRange,
                                        value: date_range || [],
                                        onClear: handleClearDateRange,
                                        allowClear: true,
                                        placeholder: t("INTERVIEW_STUDENT_DATE_RANGE")
                                    }
                                },
                                {
                                    seq: 3,
                                    type: "SELECT",
                                    gridProps: {
                                        xs: 12,
                                        md: 2
                                    },
                                    fieldProps: {
                                        labelId: "ss",
                                        heading: "",
                                        onChange: (e) => {
                                            // handleChange('form_type', index, e.target.value);
                                            set_id_degree(e.target.value)
                                        },
                                        options: [{
                                            label: t('INTERVIEW_STUDENT_ALL_LEVELS'),
                                            value: "ALL",
                                        }, ...degree?.map((item: any) => {
                                            return {
                                                label: item?.degree_name,
                                                value: item?.id_degree,
                                            }
                                        })],
                                        selectId: "",
                                        value: id_degree || '',
                                    }
                                },
                                {
                                    seq: 4,
                                    type: "SELECT",
                                    gridProps: {
                                        xs: 12,
                                        md: 2
                                    },
                                    fieldProps: {
                                        labelId: "ss",
                                        heading: "",
                                        onChange: (e) => {
                                            // handleChange('form_type', index, e.target.value);
                                            set_id_faculty(e.target.value)
                                        },
                                        options: [{
                                            label: t('INTERVIEW_STUDENT_ALL_COURSES'),
                                            value: "ALL",
                                        }, ...faculty?.map((item: any) => {
                                            return {
                                                label: item?.faculty_name,
                                                value: item?.id_faculty,
                                            }
                                        })],
                                        selectId: "",
                                        value: id_faculty || '',
                                    }
                                },
                                {
                                    seq: 5,
                                    type: "SELECT",
                                    gridProps: {
                                        xs: 12,
                                        md: 2
                                    },
                                    fieldProps: {
                                        labelId: "ss",
                                        heading: "",
                                        onChange: (e) => {
                                            // handleChange('form_type', index, e.target.value);
                                            set_status(e.target.value)
                                        },
                                        options: [
                                            {
                                                label: t('ทุกสถานะ'),
                                                value: "ALL",
                                            },
                                            {
                                                label: t('ผ่านสอบสัมภาษณ์'),
                                                value: "PASS",
                                            },
                                            {
                                                label: t('ไม่ผ่านสอบสัมภาษณ์'),
                                                value: "NOT_PASS",
                                            },
                                        ],
                                        selectId: "",
                                        value: status || '',
                                    }
                                },


                            ]}
                        />

                        <section className='w-full mt-4'>
                            <TableCustom
                                tableMinWidth={1440}
                                tableFixedWidth
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy={sortBy}
                                sortType={sortType}
                                headCells={headCells}
                                rowCount={totalItems}
                                rowsData={data?.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={handleRequestSort}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        </section>
                    </div>
                }
            />
            {showModal === 'CREATE' && (
                <ModalCustom
                    open
                    title={t('INTERVIEW_STUDENT_INTERVIEW_INFO')}
                    subTitle={t("INTERVIEW_STUDENT_COMPLETE_INFO_REQUIRED")}
                    // maxWidth={600}
                    onClose={handleCloseModal}
                    containerButton={{
                        disabled_submit: !form?.interview_student_date || !form?.interview_student_time || !form?.interview_student_link,
                        // hidden_submit: showModal === 'CREATE',
                        onClose: handleCloseModal,
                        onSubmit: () => { handleSubmit() }
                    }}
                    component={
                        <div className='w-full'>
                            <StateComponents
                                otherProps={{ spacing: 2 }}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "DATE",
                                        gridProps: {
                                            xs: 12,
                                            // md: 3
                                        },
                                        fieldProps: {
                                            onChange: (e) => { set_form({ ...form, interview_student_date: moment(e).format('YYYY-MM-DD') }) },
                                            heading: t('INTERVIEW_STUDENT_INTERVIEW_DATE'),
                                            placeholder: t('INTERVIEW_STUDENT_INTERVIEW_DATE'),
                                            allowClear: true,
                                            onClear: () => {
                                                set_form({ ...form, interview_student_date: '' })
                                            },
                                            value: form?.interview_student_date || ''
                                        },
                                    },
                                    {
                                        seq: 2,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                            // md: 3
                                        },
                                        fieldProps: {
                                            heading: t("INTERVIEW_STUDENT_INTERVIEW_TIME"),
                                            onChange: (e) => { set_form({ ...form, interview_student_time: e.target.value }) },
                                            type: 'time',
                                            value: form?.interview_student_time || ''
                                        }
                                    },

                                    {
                                        seq: 6,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                            // md: 6
                                        },
                                        fieldProps: {
                                            heading: t("INTERVIEW_STUDENT_INTERVIEW_LINK"),
                                            onChange: (e) => {
                                                set_form({ ...form, interview_student_link: e.target.value })
                                            },
                                            value: form?.interview_student_link || ''
                                        }
                                    },
                                ]} />
                        </div>
                    }
                />
            )}
            {showModal === 'REJECT' && (
                <ModalCustom
                    open
                    title={t('INTERVIEW_STUDENT_REJECTED')}
                    subTitle={t("INTERVIEW_STUDENT_NOTE")}
                    // maxWidth={600}
                    onClose={handleCloseModal}
                    containerButton={{
                        disabled_submit: !remark,
                        // hidden_submit: showModal === 'VIEW',
                        onClose: handleCloseModal,
                        onSubmit: () => { handleAPPROVE("REJECT") }
                    }}
                    component={
                        <div className='w-full'>
                            <StateComponents
                                otherProps={{ spacing: 2 }}
                                typeProps={[


                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                            // md: 6
                                        },
                                        fieldProps: {
                                            heading: t("INTERVIEW_STUDENT_NOTE"),
                                            onChange: (e) => {
                                                set_remark(e.target.value)
                                            },
                                            value: remark || '',
                                            minRow: 6,
                                            multiline: true,
                                            inputHeight: 'auto'
                                        }
                                    },
                                ]} />
                        </div>
                    }
                />
            )}

        </div>
    )
}
